module.exports = __webpack_public_path__ + "img/american-dream-logo.90733e11.jpg";